module.exports = __webpack_public_path__ + "img/carousels.157dc8a7.png";